import { gql } from '@apollo/client';

const CREATE_SHIPMENT_LABEL = gql`
  mutation createShipmentLabel($input: CreateShipmentLabelInput!) {
    createShipmentLabel(input: $input) {
      isSuccess
      message
    }
  }
`;

export default CREATE_SHIPMENT_LABEL;
